module.exports = __webpack_public_path__ + "img/sixtogo.b5dfe63d.jpeg";